// Morning brief panel (prototype scene 3): one line per employee from real data, as they report at the meeting
// table. "Back to work" sends everyone back to their desks; while the lines are still coming, "Stop waiting" does.
import { useEffect, useRef } from 'react';
import Avatar from '../Avatar';

const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export default function MorningBrief({ lines, done, leaving, agentsById, approvals, onBack, onApprovals }) {
  const d = new Date();
  const ref = useRef(null);
  // Bring the panel into view when it opens and again when it is finished (not on every line, so the office
  // picture above doesn't keep moving).
  useEffect(() => {
    if (ref.current && ref.current.scrollIntoView) ref.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }, [done]);
  return (
    <div className="brief" ref={ref}>
      <h2>Morning brief · {DAYS[d.getDay()]} {d.getDate()} {MONTHS[d.getMonth()]}</h2>
      <ul>
        {lines.map((l) => {
          const a = agentsById[l.agentId];
          return (
            <li key={l.agentId}>
              <Avatar agent={a} size="sm" />
              <div><b>{a ? `${a.name} · ${a.role}` : l.agentId}</b><p>{l.text}</p></div>
            </li>
          );
        })}
        {!done && <li className="brief-wait"><span className="typing"><i /><i /><i /></span><p>Everyone is checking their numbers…</p></li>}
      </ul>
      <div style={{ display: 'flex', gap: 8, marginTop: 12, flexWrap: 'wrap' }}>
        {done
          ? <button className="aio-btn pri" onClick={onBack} disabled={leaving}>{leaving ? 'Going back to their desks…' : 'Back to work'}</button>
          : <button className="aio-btn" onClick={onBack} disabled={leaving}>Stop waiting</button>}
        {done && approvals > 0 && <button className="aio-btn" onClick={onApprovals}>See {approvals} {approvals === 1 ? 'approval' : 'approvals'}</button>}
      </div>
    </div>
  );
}
